var moduleMap = {
	"./main": function() {
		return Promise.all([__webpack_require__.e(6088), __webpack_require__.e(4826), __webpack_require__.e(9221), __webpack_require__.e(3338), __webpack_require__.e(6113), __webpack_require__.e(1454), __webpack_require__.e(4809), __webpack_require__.e(2325), __webpack_require__.e(2950), __webpack_require__.e(9856), __webpack_require__.e(2181), __webpack_require__.e(7054), __webpack_require__.e(6632), __webpack_require__.e(2603), __webpack_require__.e(133), __webpack_require__.e(1594), __webpack_require__.e(5376), __webpack_require__.e(5431)]).then(function() { return function() { return (__webpack_require__(38978)); }; });
	},
	"./fxCharts": function() {
		return Promise.all([__webpack_require__.e(2950), __webpack_require__.e(9856), __webpack_require__.e(4507)]).then(function() { return function() { return (__webpack_require__(34507)); }; });
	}
};
var get = function(module, getScope) {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(function() {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = function(shareScope, initScope) {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: function() { return get; },
	init: function() { return init; }
});